export default {
  checkLoader: (state, payload) => {
    state.loading = payload.status
    document.body.classList.remove("no_scroll", "no_click")
  },
}
